import styled from "styled-components";

export const AddressTitle = styled.h5`
  font-size: 18px;
  font-weight: 500;
  font-family: "Roboto";
  line-height: 20px;
  text-align: start;
`;
